import React from "react";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { BranchAssignmentForm } from "./BranchAssignmentComponents/BranchAssignmentForm";
import { useCreateBranchAssignmentMutation } from "store/services/branchAssignmentApi";
import { sanitizeObject } from "utils/sanitizeObject";

const BranchAssignmentCreateScreen = () => {
  const [
    createBranchAssignment,
    { isLoading: creatingBranchAssignment, error },
  ] = useCreateBranchAssignmentMutation();
  const navigate = useNavigate();

  const breadcrumbs = [
    {
      title: "Branch-Assignment",
      path: "/app/crm/branchAssignment/list",
    },

    { title: "New Branch Assignment" },
  ];

  // create branch assignment

  const handleCreateBranchAssignment = async (data) => {
    const regionIds =
      data?.region?.map((item) => item.id).filter(Boolean) || [];
    const districtIds =
      data?.district?.map((item) => item.id).filter(Boolean) || [];
    const municipalityIds =
      data?.municipality?.map((item) => item.id).filter(Boolean) || [];
    const branchIds =
      data?.branches?.map((item) => item.id).filter(Boolean) || [];

    try {
      const payload = {
        branches: branchIds,
        region: regionIds,
        district: districtIds,
        municipality: municipalityIds,
        user: data.user?.id,
        status: data.status === true ? "Active" : "Inactive",
        assignmentType: data.assignmentType || undefined,
        hasCustomAssignment: Boolean(data.hasCustomAssignment),
      };

      await createBranchAssignment(sanitizeObject(payload)).unwrap();

      navigate(breadcrumbs[0].path);
      toast.success("Branch Assignment created successfully");
    } catch (err) {
      toast.error(
        err?.data?.message ??
        err?.message ??
        "Couldn't create Branch Assignment!",
      );
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={creatingBranchAssignment}
    >
      <BreadcrumbLayout.Error error={error} />
      <BreadcrumbLayout.Paper>
        <BranchAssignmentForm
          isBusy={creatingBranchAssignment}
          onSubmit={handleCreateBranchAssignment}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default BranchAssignmentCreateScreen;
